import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HomeHeroSection from '../components/HomeHeroSection';
import { Link } from 'react-router-dom';
import "../styles/home.css";
import "../styles/maintenance.css";
import residentialProject from '../data/featuredProjects/residential';
import commercialProject from '../data/featuredProjects/commercial';
import maintenanceProject from '../data/featuredProjects/maintenance';
import currentProject from '../data/featuredProjects/current';
// import EcoFriendlySection from '../components/EcoFriendlySection.js';
import TreeFarmComponent from "../components/TreeFarmComponent";
import "../styles/ecoFriendlySection.css";
// import NaturalisticDesignSection from '../components/NaturalisticDesignSection.js';
import IntegratedPropertySolutionsSection from '../components/IntegratedPropertySolutionsSection.js';
import AboutUsComponent from '../components/AboutUsComponent';

const Home = () => {
   const allProjects = {
    residential: residentialProject,
    commercial: commercialProject,
    maintenance: maintenanceProject,
    current: currentProject
  };
  const [selectedCategory, setSelectedCategory] = useState('residential');
  const selectedProject = allProjects[selectedCategory] || residentialProject;
  return (
    <div className="home-page">
      <Navbar />
      <HomeHeroSection/>

{/* Why Choose Us - Updated Version */}
{/* Why Choose Us - Updated Version */}
<section className="section why-all-seasons-hero">
  <div className="section-inner">
    <div className="text-center mb-4">
      <h2 className="section-title">Built on Trust. Driven by Excellence.</h2>
      {/* <h5 className="why-hero-subtitle">Four decades of excellence in Sun Valley's unique landscape</h5> */}
    </div>
    
    <div className="value-props-grid">
      <div className="value-prop-card featured">
        <div className="value-number">35+</div>
        <h3>Years of Trust</h3>
        <p className="value-description">
          Built on a history of trust, we continue to serve valley families with landscapes that last for generations.
        </p>
        <Link to="/TeamPage#about-us" className="value-link">
          Our Legacy <span className="arrow">→</span>
        </Link>
      </div>
      
      <div className="value-prop-card">
        <div className="value-number">4</div>
        <h3>True Four-Season Service</h3>
        <p className="value-description">
          From spring plantings and installations to snow removal and holiday lighting; we’re the only landscaping team you need year-round.
        </p>
        <Link to="/Premium" className="value-link">
          Explore All Services <span className="arrow">→</span>
        </Link>
      </div>
      
      <div className="value-prop-card">
        <div className="value-number">60+</div>
        <h3>Local Professionals</h3>
        <p className="value-description">
          Over 30 years of team experience, bringing mountain- specific expertise to every season.
        </p>
        <Link to="/TeamPage#team-members" className="value-link">
          Meet the Team <span className="arrow">→</span>
        </Link>
      </div>
      
      {/* Box 4 */}
      <div className="value-prop-card">
        <div className="value-number">365</div>
        <h3>Days of Dependable Care</h3>
        <p className="value-description">
          Snow. Trees. Irrigation. We show up — on time, in every season, no matter the weather.
        </p>
        <Link to="/maintenance" className="value-link">
          Explore Maintenance <span className="arrow">→</span>
        </Link>
      </div>
    </div>
  </div>
</section>
{/* All Seasons Advantage - 3 Cards */}
      <section className="all-seasons-advantage">
        <div className="advantage-container">
          <div className="advantage-header">
            <h2>The All Seasons Advantage</h2>
            <p className="advantage-subtitle">Complete outdoor management from one trusted partner</p>
          </div>

          <div className="advantage-visual-grid">
            <div className="advantage-card-visual" data-number="01">
              <div className="card-image">
                <img src="/images/flower/flowersBright1.jpg" alt="Vibrant seasonal flowers" />
              </div>
              <div className="card-content">
                <h3>Comprehensive Care, Season After Season</h3>
                <ul>
                  <li>Complete irrigation system installation & maintenance</li>
                  <li>Weekly property walks to ensure consistent quality</li>
                  <li>Snow & ice management, from sidewalks to rooftops</li>
                  <li>One contract covers everything outside</li>
                </ul>
                <p className="bottom-text">Long-term savings through intelligent design</p>
              </div>
            </div>

            <div className="advantage-card-visual" data-number="02">
              <div className="card-image">
                <img src="/images/flower/flowerBasket1.jpg" alt="Professional landscape maintenance" />
              </div>
              <div className="card-content">
                <h3>Proactive Service You Can Count On</h3>
                <ul>
                  <li>Weekly oversight to catch issues before they escalate</li>
                  <li>Seasonal preparation to keep properties ready year-round</li>
                  <li>Detailed attention to every outdoor element, no matter the season</li>
                  <li>Real-time updates via Aspire platform</li>
                </ul>
                <p className="bottom-text">One contract covers everything outside</p>
              </div>
            </div>

            <div className="advantage-card-visual highlighted" data-number="03">
              <div className="card-image">
                <img src="/images/team/Emergentresponse1.jpg" alt="24/7 emergency response team" />
              </div>
              <div className="card-content">
                <h3>24/7 Emergency Response</h3>
                <ul>
                  <li>Emergency snow removal from rooftops and access points</li>
                  <li>Rapid response to ice buildup, winter hazards</li>
                  <li></li>
                  <li>Always available — we answer when others won’t</li>
                </ul>
                <p className="bottom-text">We answer when others won't</p>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* Maintenance Solutions - Moved above About */}
<section className="component-property">
  <h2 className="section-title">MAINTENANCE SOLUTIONS</h2>
  <IntegratedPropertySolutionsSection layout="compact" />
</section>
{/* About All Seasons - Compact Version */}
<AboutUsComponent variant="compact" />

{/* Featured Services */}
{/* <section className="section bg-soft-stone">
  <div className="section-inner text-center services-section">
    <h2 className="section-title">Featured Services</h2>
    <h5 className='scrolling-text'>Explore our full range →</h5>
    <div className="services-scroll">
      <Link to="/maintenance" className="service-float">
        <img src="/images/designAS.png" alt="Design/Build service" />
        <div className="service-content">
          <p className="service-title">MAINTENANCE</p>
          <span className="service-benefit">Keep landscapes thriving year-round</span>
        </div>
      </Link>
      <Link to="/hardscape" className="service-float">
        <img src="/images/hardscape/hardscapeAS.png" alt="Hardscape service" />
        <div className="service-content">
          <p className="service-title">HARDSCAPE</p>
          <span className="service-benefit">Built to last Idaho's mountain climate</span>
        </div>
      </Link>
      <Link to="/gallery/landscape" className="service-float">
        <img src="/images/landscape/flowersTreeFence.JPG" alt="Outdoor kitchen" />
        <div className="service-content">
          <p className="service-title">LANDSCAPE</p>
          <span className="service-benefit">Custom designs for mountain living</span>
        </div>
        </Link>
        <Link to="flower" className="service-float">
        <img src="/images/flower/flowers.jpeg" alt="flowers" />
        <div className="service-content">
          <p className="service-title">FLOWERS</p>
          <span className="service-benefit">Seasonal color that thrives at altitude</span>
        </div>
      </Link>
      <Link to="/WaterFeature" className="service-float">
        <img src="/images/water/waterfall.png" alt="Maintenance service" />
        <div className="service-content">
          <p className="service-title">IRRIGATION</p>
          <span className="service-benefit">Smart systems for water efficiency</span>
        </div>
      </Link>
      <Link to="/Snow" className="service-float">
        <img src="/images/snowRemovalAS.png" alt="Snow Removal service" />
        <div className="service-content">
          <p className="service-title">SNOW REMOVAL</p>
          <span className="service-benefit">Professional winter property access</span>
        </div>
      </Link>
      <Link to="/light" className="service-float">
        <img src="/images/lighting.png" alt="lights" />
        <div className="service-content">
          <p className="service-title">HOLIDAY LIGHTS</p>
          <span className="service-benefit">Magical seasonal displays installed</span>
        </div>
        </Link>
      <Link to="/fencing" className="service-float">
        <img src="/images/fence/topRailFencing.png" alt="Fencing service" />
        <div className="service-content">
          <p className="service-title">FENCING</p>
          <span className="service-benefit">Privacy and security that lasts</span>
        </div>
      </Link>
    </div>
  </div>
</section> */}

<h2 id="treefarm-home" className="section-title">Our Tree Farm</h2>
 <TreeFarmComponent variant="compact" />

   {/* Featured Project */}
{/* Featured Project - Now Dynamic */}
<section className="section bg-clean">
  <div className="section-inner">
    <div className="advantage-header">
      <h2 className="section-title">Featured Projects</h2>
      <p className="advantage-subtitle">Every property tells a story of craft, care, and collaboration. Here's a look at a few projects that reflect what we do best: landscapes built with precision, maintained with pride, and designed to last.</p>
    </div>
    {/* Season Tabs */}
    <div className="season-tabs">
      <button 
        className={`season-tab ${selectedCategory === 'residential' ? 'active' : ''}`}
        onClick={() => setSelectedCategory('residential')}
      >
        <span className="season-icon"></span>
        Residential Landscaping
      </button>
      <button 
        className={`season-tab ${selectedCategory === 'commercial' ? 'active' : ''}`}
        onClick={() => setSelectedCategory('commercial')}
      >
        <span className="season-icon"></span>
        Commercial Landscaping
      </button>
      <button 
        className={`season-tab ${selectedCategory === 'maintenance' ? 'active' : ''}`}
        onClick={() => setSelectedCategory('maintenance')}
      >
        <span className="season-icon"></span>
        Maintenance Programs
      </button>
      <button 
        className={`season-tab ${selectedCategory === 'current' ? 'active' : ''}`}
        onClick={() => setSelectedCategory('current')}
      >
        <span className="season-icon"></span>
        Current Project
      </button>
    </div>

    {/* Project Content */}
    {selectedProject && selectedProject.images ? (
      <div className="featured-project-alt">
        <div className="project-left">
          <div className="image-hover">
            <img src={selectedProject.images.topLeft.top} alt={selectedProject.images.topLeft.topAlt} className="top" />
            <img src={selectedProject.images.topLeft.bottom} alt={selectedProject.images.topLeft.bottomAlt} className="bottom" />
          </div>
          <div className="image-hover">
            <img src={selectedProject.images.bottomLeft.top} alt={selectedProject.images.bottomLeft.topAlt} className="top" />
            <img src={selectedProject.images.bottomLeft.bottom} alt={selectedProject.images.bottomLeft.bottomAlt} className="bottom" />
          </div>
        </div>
        <div className="project-right">
          <h2>{selectedProject.title}</h2>
          {selectedProject.paragraphs && selectedProject.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    ) : (
      <div className="loading-placeholder">Loading project...</div>
    )}
  </div>
</section>

{/* What We Maintain - Visual Gallery */}
<section className="what-we-maintain">
  <div className="maintain-container">
    <div className="maintain-header">
      <h2>What We Maintain</h2>
      <p>Every element of your outdoor space receives expert care and attention</p>
    </div>

    <div className="maintain-gallery">
      <div className="maintain-item maintain-item--wide">
        <img src="/images/water/pondCreated1.jpg" alt="Water feature maintenance" />
        <div className="maintain-overlay">
          <h3>Water Features</h3>
          <p>Ponds • Lakes • Fountains • Irrigation Systems</p>
        </div>
      </div>

      <div className="maintain-item">
        <img src="/images/maintenance/grassBig.JPG" alt="Grass and turf maintenance" />
        <div className="maintain-overlay">
          <h3>Grass & Turf</h3>
          <p>Manicured lawns • Prairie meadows</p>
        </div>
      </div>

      <div className="maintain-item">
        <img src="/images/tree/treeHeroImage3.jpg" alt="Tree care and maintenance" />
        <div className="maintain-overlay">
          <h3>Trees</h3>
          <p>Pruning • Health monitoring • Removal</p>
        </div>
      </div>

      <div className="maintain-item maintain-item--wide-short">
        <img src="/images/flower/flowersBright1.jpg" alt="Shrub and flower care" />
        <div className="maintain-overlay">
          <h3>Shrubs & Flowers</h3>
          <p>Seasonal color • Year-round beauty</p>
        </div>
      </div>
    </div>

  </div>
</section>

{/* <section>
<h2 className="section-title">Naturalistic Design</h2>
<NaturalisticDesignSection layout="teaser" />
</section> */}
{/* Eco-Friendly Practices Section */}
        {/* <section classname="eco">
        <h2 className="section-title text-center">Eco Friendly</h2>
        <EcoFriendlySection 
        layout="compact"      // Smaller layout perfect for homepage
        showTitle={true}
        showCTA={true}       // No CTA to keep it concise
        variant="light"
        context="residential"
        ctaOverrideLink="/EcoPage" 
      />
    </section> */}
      
{/* Bottom CTAs */}
<section className="section bg-white bottom-ctas-section">
  <div className="section-inner">
    <div className="bottom-ctas">
      <div className="cta-box">
        <h3>Request a Bid</h3>
        <p>
          Ready to start your next landscaping project? We'd love to hear from you.
        </p>
        <a
          className="btn-primary"
          href="mailto:info@allseasons.info"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </div>
      <div className="cta-box">
        <h3>Work With Us</h3>
        <p>
          Interested in joining the team? We're always looking for skilled, motivated people.
        </p>
        <Link
          className="btn-cta"
          to="/ApplyHere">Apply Now
        </Link>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default Home;
